import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import AppRoutes from "./routes";
import { Theme } from "./utils/theme-config";
import Loader from "./core/loader";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AppProvide } from "./utils/context";
import "react-toastify/dist/ReactToastify.css";
import "./styles/index.scss";
import { TabContext } from "./core/global-data";
import { setOfflineData } from "./utils/offline-services";

const theme = createTheme(Theme);
function App() {
  const [tabValue, setTabValue] = useState(0);

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Loader />
        <ToastContainer autoClose={8000} />
        <TabContext.Provider value={{ tabValue, setTabValue }}>
          <AppRoutes />
        </TabContext.Provider>
      </ThemeProvider>
    </div>
  );
}

export default App;
